/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  CardBody,
  CardContent,
  CardMedia,
  CardTitle,
  Link,
  Typography,
} from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import { clickEvent, impressionEvent } from '../../utils/publisher';
import { B2B_DEFAULT_APPLYNOW_URL, CARD_IMAGE } from '../../utils/constants';
import { clickApplyNow, getDefaultApplyNowURL, loadEstimatorScript } from '../../utils/payment-estimator-utils';
import ProXtraDrawer from '../../common/pro-xtra-drawer.component';

const ApplyNowB2B = ({ paymentEstimatorVersion = 'v1.0.29', isMobile = false, id = '', experience = 'homepage' }) => {
  const [applyNowLink, setApplyNowLink] = useState(B2B_DEFAULT_APPLYNOW_URL);
  const [showDrawer, setShowDrawer] = React.useState(false);
  const [paymentEstimatorLoaded, setPaymentEstimatorLoaded] = useState(false);

  const openDrawer = () => {
    setShowDrawer(true);
  };

  const closeDrawer = () => {
    setShowDrawer(false);
  };

  const analyticsInteraction = () => {
    clickEvent('plcc-apply now');
  };

  useEffect(() => {
    loadEstimatorScript(
      paymentEstimatorVersion,
      () => setApplyNowLink(getDefaultApplyNowURL(isMobile, experience, true)),
      setPaymentEstimatorLoaded(true),
      isMobile
    );
    impressionEvent('plcc-apply now');
  }, []);

  const { ref, clickID } = useImpression({
    data: {
      id,
      name: 'PLCCPod',
      component: 'PLCCPod',
      position: 1,
      type: 'content',
    },
  });
  const applyNowMessage = () => {
    return (
      // eslint-disable-next-line react/no-unknown-property
      <div clickid={clickID} ref={ref}>
        <div className="sui-flex sui-place-content-center sui-bg-subtle sui-px-10 sui-py-6">
          <CardMedia
            key="B2BCardImage"
            className="sui-object-fill"
            src={CARD_IMAGE.PLCR_HOMEDEPOT}
            alt="Credit Card Icon"
            aspect="wide"
          />
        </div>
        <CardBody>
          <div className="sui-flex sui-flex-col sui-gap-4 sui-pt-4 sui-pb-4">
            <Typography variant="h6" weight="bold">
              Earn Pro Xtra Perks 4X faster* on qualifying purchases when you join Pro Xtra,
              register, & use your card
            </Typography>
            <Typography variant="body-xs" color="subtle">
              See{' '}
              <span className="sui-align-text-bottom">
                <Link component="button" onClick={openDrawer} variant="body-xs">
                  terms & conditions
                </Link>
              </span>{' '}
              for offer details.
            </Typography>
          </div>
        </CardBody>
        <div>
          <Button
            data-testid="apply-now-b2b"
            variant="secondary"
            fullWidth
            href={applyNowLink}
            onClick={analyticsInteraction}
          >
            Apply Now
          </Button>
        </div>
      </div>
    );
  };

  return (
    <CardContent
      className="sui-flex sui-flex-col sui-gap-4 sui-h-full sui-w-full"
      clickid={clickID}
      ref={ref}
      data-component="ApplyNowB2B"
    >
      <CardTitle
        disableTypography
        header={<Typography variant="h3">Home Depot Credit Cards</Typography>}
      />
      {showDrawer && (
        <ProXtraDrawer
          closeDrawer={() => closeDrawer(false)}
          open={showDrawer}
          applyNowClick={() => clickApplyNow('plcc-apply now', null, isMobile, applyNowLink)}
        />
      )}
      {applyNowMessage()}
    </CardContent>
  );
};

ApplyNowB2B.propTypes = {
  id: PropTypes.string,
  paymentEstimatorVersion: PropTypes.string,
  isMobile: PropTypes.bool,
  experience: PropTypes.string,
};

export default ApplyNowB2B;
